/* eslint-disable */

export const protobufPackage = "store.api";

export enum ErrorType {
  /** UNKNOWN - Unknown error. */
  UNKNOWN = 0,
  /**
   * EMPTY_ARGUMENT - Empty argument error for common use. Note: emit this error for empty strings, nil arguments, or empty slices;
   * otherwise, ZERO_VALUE_ARGUMENT.
   */
  EMPTY_ARGUMENT = 1,
  /** ZERO_VALUE_ARGUMENT - Indicates user inputs 0, or other zero values. */
  ZERO_VALUE_ARGUMENT = 2,
  /** INVALID_FORMAT_ARGUMENT - Indicates values user inputs are of wrong format. */
  INVALID_FORMAT_ARGUMENT = 3,
  /** BATCH_LIMIT_EXCEEDED - Indicates there are too many subjects in a batch operation. */
  BATCH_LIMIT_EXCEEDED = 4,
  /** DUPLICATED_ARGUMENTS - Indicates duplicate data has been found in DB, manually checked before DB inserting. */
  DUPLICATED_ARGUMENTS = 5,
  /** SENSITIVE_WORDS - Indicates some string contains sensitive words. */
  SENSITIVE_WORDS = 6,
  /**
   * RETRYABLE_INTERNAL_ERROR - Indicates an internal error which can be resolved by retrying later. If an internal error is not retryable, just
   * don't return any custom error code.
   */
  RETRYABLE_INTERNAL_ERROR = 7,
  /** PERMISSION_DENIED - Indicates permission denied. */
  PERMISSION_DENIED = 8,
  /** DB_DUPLICATE_ENTRY - Indicates inserting duplicate primary key or breaking unique constraint in DB and key could be parse from sql error message. */
  DB_DUPLICATE_ENTRY = 50,
  /** DB_DATA_TOO_LONG - Indicates data too long error in DB. */
  DB_DATA_TOO_LONG = 51,
  /** DB_DATA_OUT_OF_RANGE - Indicates data out of range error in DB. */
  DB_DATA_OUT_OF_RANGE = 52,
  /**
   * TOKEN_EXPIRED - The user's access token is expired or refresh token has been revoked.
   * Client should takes corresponding action to this error type.
   * For an expired access token client should try to renew token
   * by Token.Refresh with a refresh token.  If refresh token has been revoked,
   * client must ask user sign-in again.
   */
  TOKEN_EXPIRED = 100,
  /**
   * REQUEST_THROTTLED - The request has been declined due to too many attempts in a short time. Try again later.
   * Each auth methods has different throttle rule and backoff time.  Client must respect
   * to the spec and take care of retry backoff time in implementation.
   */
  REQUEST_THROTTLED = 101,
  /** OPERATION_NOT_ALLOWED - The operation (sign-in action or user data update) is disabled. */
  OPERATION_NOT_ALLOWED = 102,
  /**
   * EMAIL_EXISTS - Account data state errors.
   * Email address is already used.
   */
  EMAIL_EXISTS = 103,
  /** USER_DISABLED - The user account has been disabled. */
  USER_DISABLED = 104,
  /** USER_NOT_FOUND - There is no user record to the identifier. */
  USER_NOT_FOUND = 105,
  /**
   * EMAIL_NOT_FOUND - There is no user record corresponding to this email.
   * Or user does not have an email.
   */
  EMAIL_NOT_FOUND = 106,
  /** PASSWORD_NOT_FOUND - User does not have a password. */
  PASSWORD_NOT_FOUND = 107,
  /** FEDERATED_ID_ALREADY_EXISTS - Identity resolved from an external IDP credential has already been used. */
  FEDERATED_ID_ALREADY_EXISTS = 108,
  /**
   * INVALID_REFRESH_TOKEN - API argument errors.
   * Invalid (malformed) refresh token is provided.
   */
  INVALID_REFRESH_TOKEN = 109,
  /** MISSING_REFRESH_TOKEN - No refresh token provided. */
  MISSING_REFRESH_TOKEN = 110,
  /** INVALID_ACCESS_TOKEN - Invalid (malformed) access token is provided. */
  INVALID_ACCESS_TOKEN = 111,
  /** MISSING_ACCESS_TOKEN - No access token provided. */
  MISSING_ACCESS_TOKEN = 112,
  /** INVALID_GRANT_TYPE - Specified grant type is invalid */
  INVALID_GRANT_TYPE = 113,
  /** INVALID_PASSWORD - Provided password is invalid, too weak or malformed. */
  INVALID_PASSWORD = 114,
  /** INVALID_AUTH_CREDENTIAL - Provided auth credential is invalid. */
  INVALID_AUTH_CREDENTIAL = 115,
  /** INVALID_IDP_RESPONSE - The supplied auth credentials is malformed or expired. */
  INVALID_IDP_RESPONSE = 116,
  /** INVALID_PUSH_DEVICE_ID - Invalid push device id. */
  INVALID_PUSH_DEVICE_ID = 117,
  /** INVALID_PLATFORM - Invalid platform. */
  INVALID_PLATFORM = 118,
  /** ORDER_INVALID_PAYMENT_TYPE - 請選擇正確的付款方式。 */
  ORDER_INVALID_PAYMENT_TYPE = 150,
  /** ORDER_INVALID_TOTAL - 訂單成立失敗，金額發生錯誤。 */
  ORDER_INVALID_TOTAL = 151,
  /** ORDER_EMPTY_CART_ITEM - 請選擇購物車商品。 */
  ORDER_EMPTY_CART_ITEM = 152,
  /** ORDER_INVALID_CART_ITEM - 請選擇正確的購物車商品。 */
  ORDER_INVALID_CART_ITEM = 153,
  /** ORDER_DUPLICATE_CART_ITEM - 購物車內有重複的購物車商品。 */
  ORDER_DUPLICATE_CART_ITEM = 154,
  /** ORDER_INVALID_CART_ITEM_IS_NEGATIVE - 購物車商品數量必須大於0。 */
  ORDER_INVALID_CART_ITEM_IS_NEGATIVE = 155,
  /** ORDER_INVALID_RECEIPT_METHOD - 請選擇正確的發票類型。 */
  ORDER_INVALID_RECEIPT_METHOD = 156,
  /** ORDER_INVALID_MOBILE_BARCODE - 請輸入正確的手機條碼。 */
  ORDER_INVALID_MOBILE_BARCODE = 157,
  /** ORDER_INVALID_TAX_ID - 請輸入正確的統一編號。 */
  ORDER_INVALID_TAX_ID = 158,
  /** ORDER_INVALID_DONATE_UNIT - 請選擇正確的捐贈單位。 */
  ORDER_INVALID_DONATE_UNIT = 159,
  /** ORDER_EMPTY_RECIPIENT_INFO - 收件人資訊不可為空。 */
  ORDER_EMPTY_RECIPIENT_INFO = 160,
  /** ORDER_EMPTY_RECIPIENT_NAME - 請輸入姓名。 */
  ORDER_EMPTY_RECIPIENT_NAME = 161,
  /** ORDER_RECIPIENT_NAME_INCLUDE_NUMBER - 姓名不可輸入數字。 */
  ORDER_RECIPIENT_NAME_INCLUDE_NUMBER = 162,
  /** ORDER_EMPTY_RECIPIENT_PHONE - 請輸入手機號碼。 */
  ORDER_EMPTY_RECIPIENT_PHONE = 163,
  /** ORDER_INVALID_RECIPIENT_PHONE - 請輸入正確的手機號碼。 */
  ORDER_INVALID_RECIPIENT_PHONE = 164,
  /** ORDER_EMPTY_PICKUP_STORE - 請選擇收件門市。 */
  ORDER_EMPTY_PICKUP_STORE = 165,
  /** ORDER_INVALID_CREDIT_CARD_NUMBER - 請輸入正確的信用卡卡號。 */
  ORDER_INVALID_CREDIT_CARD_NUMBER = 166,
  /** ORDER_INVALID_CREDIT_CARD_GOOD_THRU - 請輸入正確的信用卡有效期限。 */
  ORDER_INVALID_CREDIT_CARD_GOOD_THRU = 167,
  /** ORDER_INVALID_CREDIT_CARD_CVV - 請輸入正確的信用卡末三碼。 */
  ORDER_INVALID_CREDIT_CARD_CVV = 168,
  /** ORDER_EMPTY_FIRST_NAME - 請輸入名字。 */
  ORDER_EMPTY_FIRST_NAME = 169,
  /** ORDER_EMPTY_LAST_NAME - 請輸入姓氏。 */
  ORDER_EMPTY_LAST_NAME = 170,
  /** ORDER_INVALID_PHONE_COUNTRY_CODE - 請選擇正確的國碼。 */
  ORDER_INVALID_PHONE_COUNTRY_CODE = 171,
  /** ORDER_INVALID_COUNTRY - 請選擇正確的國家。 */
  ORDER_INVALID_COUNTRY = 172,
  /** ORDER_EMPTY_PROVINCE - 請輸入州/省/地區。 */
  ORDER_EMPTY_PROVINCE = 173,
  /** ORDER_EMPTY_CITY - 請輸入城市。 */
  ORDER_EMPTY_CITY = 174,
  /** ORDER_EMPTY_STREET - 請輸入門牌地址。 */
  ORDER_EMPTY_STREET = 175,
  /** ORDER_EMPTY_POSTCODE - 請輸入郵遞區號。 */
  ORDER_EMPTY_POSTCODE = 176,
  /** ORDER_EMPTY_COUNTY - 請選擇縣市。。 */
  ORDER_EMPTY_COUNTY = 177,
  /** ORDER_EMPTY_AREA - 請選擇鄉鎮市區。 */
  ORDER_EMPTY_AREA = 178,
  /** RETURN_NOT_FOUND - 查无该笔退货退款资料。 */
  RETURN_NOT_FOUND = 200,
  /** RETURN_INVALID_LOGISTICS_COMPANY - 回填的物流厂商名不存在。 */
  RETURN_INVALID_LOGISTICS_COMPANY = 201,
  /** RETURN_ORDER_ITEM_NOT_FOUND - 申请退款/退货失败，该品项已曾经申请过，请联系客服。 */
  RETURN_ORDER_ITEM_NOT_FOUND = 202,
  /** RETURN_ORDER_ITEM_ALREADY_RETURNED - 申请退款/退货失败，该品项已曾经申请过，请联系客服。 */
  RETURN_ORDER_ITEM_ALREADY_RETURNED = 203,
  /** RETURN_ORDER_REFUND_INVALID_STATE - 申请退款失败，订单不在可以申请退款的状态。 */
  RETURN_ORDER_REFUND_INVALID_STATE = 204,
  /** RETURN_ORDER_RETURN_INVALID_STATE - 申请退款失败，订单不在可以申请退款的状态。 */
  RETURN_ORDER_RETURN_INVALID_STATE = 205,
  /** RETURN_REASON_NOTE_EMPTY - 若选择「质量问题」，请详细描述退货原因。 */
  RETURN_REASON_NOTE_EMPTY = 206,
  /** RETURN_EXCEED_PURCHASE_QTY - 退货数量不可以超过购买数量。 */
  RETURN_EXCEED_PURCHASE_QTY = 207,
  /** RETURN_ORDER_ITEM_NO_RETURNS - 退货失败，该品项为不可退货商品，请联系客服。 */
  RETURN_ORDER_ITEM_NO_RETURNS = 208,
  /** RETURN_UPDATE_LOGISTICS_INVALID_STATE - 编辑失败，退货单不在可以修改单号的状态。 */
  RETURN_UPDATE_LOGISTICS_INVALID_STATE = 209,
  /** RATING_INVALID_CONTENT - 评价内容有特殊的词汇。 */
  RATING_INVALID_CONTENT = 250,
  /** RATING_TRADITIONAL_CONTENT - 评价内容的语系有误，建议您修改后重新提交。 */
  RATING_TRADITIONAL_CONTENT = 251,
  /** RATING_ORDER_ITEM_RATED - 已评价商品无法再次回评。 */
  RATING_ORDER_ITEM_RATED = 252,
  /** RATING_ORDER_NOT_CLAIMED - 订单目前非可评价状态。 */
  RATING_ORDER_NOT_CLAIMED = 253,
  /** RATING_ORDER_ITEM_RATING_EXPIRED - 订单已超过可评价时间。 */
  RATING_ORDER_ITEM_RATING_EXPIRED = 254,
  /** RATING_EMPTY_CONTENT - 请输入评价内容。 */
  RATING_EMPTY_CONTENT = 255,
  /** PRODUCT_NOT_FOUND - 商品已下架。 */
  PRODUCT_NOT_FOUND = 260,
  /** CATEGORY_NOT_FOUND - 查无此分类。 */
  CATEGORY_NOT_FOUND = 270,
  /** HOT_KEYWORD_NOT_FOUND - 查无搜寻内容。 */
  HOT_KEYWORD_NOT_FOUND = 280,
  /** SHOP_WINDOW_NOT_FOUND - 优惠活动已结束。 */
  SHOP_WINDOW_NOT_FOUND = 290,
  /** CART_ITEM_NO_SALE - 商品庫存不足 */
  CART_ITEM_NO_SALE = 300,
  /** CART_ITEM_ALL_NO_SALE - 訂單中商品皆售完，去逛逛其他商品吧～ */
  CART_ITEM_ALL_NO_SALE = 301,
  /** CART_ITEM_SOME_NO_SALE - 訂單中部分商品已售完，將其他有貨商品加入購物車吧？ */
  CART_ITEM_SOME_NO_SALE = 302,
  /** CUSTOMER_RECEIPT_EXIST - 由于发票已存在，因此无法重新申请发票。 */
  CUSTOMER_RECEIPT_EXIST = 350,
  /** CUSTOMER_RECEIPT_NOT_FOUND - 查无此笔发票资讯。 */
  CUSTOMER_RECEIPT_NOT_FOUND = 351,
  /** CUSTOMER_RECEIPT_CANNOT_MODIFY - 由于发票已开立，因此无法编辑发票资讯。 */
  CUSTOMER_RECEIPT_CANNOT_MODIFY = 352,
  /** STATIC_PAGE_NOT_FOUND - 查無靜態頁面 */
  STATIC_PAGE_NOT_FOUND = 370,
}

export function errorTypeFromJSON(object: any): ErrorType {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return ErrorType.UNKNOWN;
    case 1:
    case "EMPTY_ARGUMENT":
      return ErrorType.EMPTY_ARGUMENT;
    case 2:
    case "ZERO_VALUE_ARGUMENT":
      return ErrorType.ZERO_VALUE_ARGUMENT;
    case 3:
    case "INVALID_FORMAT_ARGUMENT":
      return ErrorType.INVALID_FORMAT_ARGUMENT;
    case 4:
    case "BATCH_LIMIT_EXCEEDED":
      return ErrorType.BATCH_LIMIT_EXCEEDED;
    case 5:
    case "DUPLICATED_ARGUMENTS":
      return ErrorType.DUPLICATED_ARGUMENTS;
    case 6:
    case "SENSITIVE_WORDS":
      return ErrorType.SENSITIVE_WORDS;
    case 7:
    case "RETRYABLE_INTERNAL_ERROR":
      return ErrorType.RETRYABLE_INTERNAL_ERROR;
    case 8:
    case "PERMISSION_DENIED":
      return ErrorType.PERMISSION_DENIED;
    case 50:
    case "DB_DUPLICATE_ENTRY":
      return ErrorType.DB_DUPLICATE_ENTRY;
    case 51:
    case "DB_DATA_TOO_LONG":
      return ErrorType.DB_DATA_TOO_LONG;
    case 52:
    case "DB_DATA_OUT_OF_RANGE":
      return ErrorType.DB_DATA_OUT_OF_RANGE;
    case 100:
    case "TOKEN_EXPIRED":
      return ErrorType.TOKEN_EXPIRED;
    case 101:
    case "REQUEST_THROTTLED":
      return ErrorType.REQUEST_THROTTLED;
    case 102:
    case "OPERATION_NOT_ALLOWED":
      return ErrorType.OPERATION_NOT_ALLOWED;
    case 103:
    case "EMAIL_EXISTS":
      return ErrorType.EMAIL_EXISTS;
    case 104:
    case "USER_DISABLED":
      return ErrorType.USER_DISABLED;
    case 105:
    case "USER_NOT_FOUND":
      return ErrorType.USER_NOT_FOUND;
    case 106:
    case "EMAIL_NOT_FOUND":
      return ErrorType.EMAIL_NOT_FOUND;
    case 107:
    case "PASSWORD_NOT_FOUND":
      return ErrorType.PASSWORD_NOT_FOUND;
    case 108:
    case "FEDERATED_ID_ALREADY_EXISTS":
      return ErrorType.FEDERATED_ID_ALREADY_EXISTS;
    case 109:
    case "INVALID_REFRESH_TOKEN":
      return ErrorType.INVALID_REFRESH_TOKEN;
    case 110:
    case "MISSING_REFRESH_TOKEN":
      return ErrorType.MISSING_REFRESH_TOKEN;
    case 111:
    case "INVALID_ACCESS_TOKEN":
      return ErrorType.INVALID_ACCESS_TOKEN;
    case 112:
    case "MISSING_ACCESS_TOKEN":
      return ErrorType.MISSING_ACCESS_TOKEN;
    case 113:
    case "INVALID_GRANT_TYPE":
      return ErrorType.INVALID_GRANT_TYPE;
    case 114:
    case "INVALID_PASSWORD":
      return ErrorType.INVALID_PASSWORD;
    case 115:
    case "INVALID_AUTH_CREDENTIAL":
      return ErrorType.INVALID_AUTH_CREDENTIAL;
    case 116:
    case "INVALID_IDP_RESPONSE":
      return ErrorType.INVALID_IDP_RESPONSE;
    case 117:
    case "INVALID_PUSH_DEVICE_ID":
      return ErrorType.INVALID_PUSH_DEVICE_ID;
    case 118:
    case "INVALID_PLATFORM":
      return ErrorType.INVALID_PLATFORM;
    case 150:
    case "ORDER_INVALID_PAYMENT_TYPE":
      return ErrorType.ORDER_INVALID_PAYMENT_TYPE;
    case 151:
    case "ORDER_INVALID_TOTAL":
      return ErrorType.ORDER_INVALID_TOTAL;
    case 152:
    case "ORDER_EMPTY_CART_ITEM":
      return ErrorType.ORDER_EMPTY_CART_ITEM;
    case 153:
    case "ORDER_INVALID_CART_ITEM":
      return ErrorType.ORDER_INVALID_CART_ITEM;
    case 154:
    case "ORDER_DUPLICATE_CART_ITEM":
      return ErrorType.ORDER_DUPLICATE_CART_ITEM;
    case 155:
    case "ORDER_INVALID_CART_ITEM_IS_NEGATIVE":
      return ErrorType.ORDER_INVALID_CART_ITEM_IS_NEGATIVE;
    case 156:
    case "ORDER_INVALID_RECEIPT_METHOD":
      return ErrorType.ORDER_INVALID_RECEIPT_METHOD;
    case 157:
    case "ORDER_INVALID_MOBILE_BARCODE":
      return ErrorType.ORDER_INVALID_MOBILE_BARCODE;
    case 158:
    case "ORDER_INVALID_TAX_ID":
      return ErrorType.ORDER_INVALID_TAX_ID;
    case 159:
    case "ORDER_INVALID_DONATE_UNIT":
      return ErrorType.ORDER_INVALID_DONATE_UNIT;
    case 160:
    case "ORDER_EMPTY_RECIPIENT_INFO":
      return ErrorType.ORDER_EMPTY_RECIPIENT_INFO;
    case 161:
    case "ORDER_EMPTY_RECIPIENT_NAME":
      return ErrorType.ORDER_EMPTY_RECIPIENT_NAME;
    case 162:
    case "ORDER_RECIPIENT_NAME_INCLUDE_NUMBER":
      return ErrorType.ORDER_RECIPIENT_NAME_INCLUDE_NUMBER;
    case 163:
    case "ORDER_EMPTY_RECIPIENT_PHONE":
      return ErrorType.ORDER_EMPTY_RECIPIENT_PHONE;
    case 164:
    case "ORDER_INVALID_RECIPIENT_PHONE":
      return ErrorType.ORDER_INVALID_RECIPIENT_PHONE;
    case 165:
    case "ORDER_EMPTY_PICKUP_STORE":
      return ErrorType.ORDER_EMPTY_PICKUP_STORE;
    case 166:
    case "ORDER_INVALID_CREDIT_CARD_NUMBER":
      return ErrorType.ORDER_INVALID_CREDIT_CARD_NUMBER;
    case 167:
    case "ORDER_INVALID_CREDIT_CARD_GOOD_THRU":
      return ErrorType.ORDER_INVALID_CREDIT_CARD_GOOD_THRU;
    case 168:
    case "ORDER_INVALID_CREDIT_CARD_CVV":
      return ErrorType.ORDER_INVALID_CREDIT_CARD_CVV;
    case 169:
    case "ORDER_EMPTY_FIRST_NAME":
      return ErrorType.ORDER_EMPTY_FIRST_NAME;
    case 170:
    case "ORDER_EMPTY_LAST_NAME":
      return ErrorType.ORDER_EMPTY_LAST_NAME;
    case 171:
    case "ORDER_INVALID_PHONE_COUNTRY_CODE":
      return ErrorType.ORDER_INVALID_PHONE_COUNTRY_CODE;
    case 172:
    case "ORDER_INVALID_COUNTRY":
      return ErrorType.ORDER_INVALID_COUNTRY;
    case 173:
    case "ORDER_EMPTY_PROVINCE":
      return ErrorType.ORDER_EMPTY_PROVINCE;
    case 174:
    case "ORDER_EMPTY_CITY":
      return ErrorType.ORDER_EMPTY_CITY;
    case 175:
    case "ORDER_EMPTY_STREET":
      return ErrorType.ORDER_EMPTY_STREET;
    case 176:
    case "ORDER_EMPTY_POSTCODE":
      return ErrorType.ORDER_EMPTY_POSTCODE;
    case 177:
    case "ORDER_EMPTY_COUNTY":
      return ErrorType.ORDER_EMPTY_COUNTY;
    case 178:
    case "ORDER_EMPTY_AREA":
      return ErrorType.ORDER_EMPTY_AREA;
    case 200:
    case "RETURN_NOT_FOUND":
      return ErrorType.RETURN_NOT_FOUND;
    case 201:
    case "RETURN_INVALID_LOGISTICS_COMPANY":
      return ErrorType.RETURN_INVALID_LOGISTICS_COMPANY;
    case 202:
    case "RETURN_ORDER_ITEM_NOT_FOUND":
      return ErrorType.RETURN_ORDER_ITEM_NOT_FOUND;
    case 203:
    case "RETURN_ORDER_ITEM_ALREADY_RETURNED":
      return ErrorType.RETURN_ORDER_ITEM_ALREADY_RETURNED;
    case 204:
    case "RETURN_ORDER_REFUND_INVALID_STATE":
      return ErrorType.RETURN_ORDER_REFUND_INVALID_STATE;
    case 205:
    case "RETURN_ORDER_RETURN_INVALID_STATE":
      return ErrorType.RETURN_ORDER_RETURN_INVALID_STATE;
    case 206:
    case "RETURN_REASON_NOTE_EMPTY":
      return ErrorType.RETURN_REASON_NOTE_EMPTY;
    case 207:
    case "RETURN_EXCEED_PURCHASE_QTY":
      return ErrorType.RETURN_EXCEED_PURCHASE_QTY;
    case 208:
    case "RETURN_ORDER_ITEM_NO_RETURNS":
      return ErrorType.RETURN_ORDER_ITEM_NO_RETURNS;
    case 209:
    case "RETURN_UPDATE_LOGISTICS_INVALID_STATE":
      return ErrorType.RETURN_UPDATE_LOGISTICS_INVALID_STATE;
    case 250:
    case "RATING_INVALID_CONTENT":
      return ErrorType.RATING_INVALID_CONTENT;
    case 251:
    case "RATING_TRADITIONAL_CONTENT":
      return ErrorType.RATING_TRADITIONAL_CONTENT;
    case 252:
    case "RATING_ORDER_ITEM_RATED":
      return ErrorType.RATING_ORDER_ITEM_RATED;
    case 253:
    case "RATING_ORDER_NOT_CLAIMED":
      return ErrorType.RATING_ORDER_NOT_CLAIMED;
    case 254:
    case "RATING_ORDER_ITEM_RATING_EXPIRED":
      return ErrorType.RATING_ORDER_ITEM_RATING_EXPIRED;
    case 255:
    case "RATING_EMPTY_CONTENT":
      return ErrorType.RATING_EMPTY_CONTENT;
    case 260:
    case "PRODUCT_NOT_FOUND":
      return ErrorType.PRODUCT_NOT_FOUND;
    case 270:
    case "CATEGORY_NOT_FOUND":
      return ErrorType.CATEGORY_NOT_FOUND;
    case 280:
    case "HOT_KEYWORD_NOT_FOUND":
      return ErrorType.HOT_KEYWORD_NOT_FOUND;
    case 290:
    case "SHOP_WINDOW_NOT_FOUND":
      return ErrorType.SHOP_WINDOW_NOT_FOUND;
    case 300:
    case "CART_ITEM_NO_SALE":
      return ErrorType.CART_ITEM_NO_SALE;
    case 301:
    case "CART_ITEM_ALL_NO_SALE":
      return ErrorType.CART_ITEM_ALL_NO_SALE;
    case 302:
    case "CART_ITEM_SOME_NO_SALE":
      return ErrorType.CART_ITEM_SOME_NO_SALE;
    case 350:
    case "CUSTOMER_RECEIPT_EXIST":
      return ErrorType.CUSTOMER_RECEIPT_EXIST;
    case 351:
    case "CUSTOMER_RECEIPT_NOT_FOUND":
      return ErrorType.CUSTOMER_RECEIPT_NOT_FOUND;
    case 352:
    case "CUSTOMER_RECEIPT_CANNOT_MODIFY":
      return ErrorType.CUSTOMER_RECEIPT_CANNOT_MODIFY;
    case 370:
    case "STATIC_PAGE_NOT_FOUND":
      return ErrorType.STATIC_PAGE_NOT_FOUND;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum ErrorType");
  }
}

export function errorTypeToJSON(object: ErrorType): string {
  switch (object) {
    case ErrorType.UNKNOWN:
      return "UNKNOWN";
    case ErrorType.EMPTY_ARGUMENT:
      return "EMPTY_ARGUMENT";
    case ErrorType.ZERO_VALUE_ARGUMENT:
      return "ZERO_VALUE_ARGUMENT";
    case ErrorType.INVALID_FORMAT_ARGUMENT:
      return "INVALID_FORMAT_ARGUMENT";
    case ErrorType.BATCH_LIMIT_EXCEEDED:
      return "BATCH_LIMIT_EXCEEDED";
    case ErrorType.DUPLICATED_ARGUMENTS:
      return "DUPLICATED_ARGUMENTS";
    case ErrorType.SENSITIVE_WORDS:
      return "SENSITIVE_WORDS";
    case ErrorType.RETRYABLE_INTERNAL_ERROR:
      return "RETRYABLE_INTERNAL_ERROR";
    case ErrorType.PERMISSION_DENIED:
      return "PERMISSION_DENIED";
    case ErrorType.DB_DUPLICATE_ENTRY:
      return "DB_DUPLICATE_ENTRY";
    case ErrorType.DB_DATA_TOO_LONG:
      return "DB_DATA_TOO_LONG";
    case ErrorType.DB_DATA_OUT_OF_RANGE:
      return "DB_DATA_OUT_OF_RANGE";
    case ErrorType.TOKEN_EXPIRED:
      return "TOKEN_EXPIRED";
    case ErrorType.REQUEST_THROTTLED:
      return "REQUEST_THROTTLED";
    case ErrorType.OPERATION_NOT_ALLOWED:
      return "OPERATION_NOT_ALLOWED";
    case ErrorType.EMAIL_EXISTS:
      return "EMAIL_EXISTS";
    case ErrorType.USER_DISABLED:
      return "USER_DISABLED";
    case ErrorType.USER_NOT_FOUND:
      return "USER_NOT_FOUND";
    case ErrorType.EMAIL_NOT_FOUND:
      return "EMAIL_NOT_FOUND";
    case ErrorType.PASSWORD_NOT_FOUND:
      return "PASSWORD_NOT_FOUND";
    case ErrorType.FEDERATED_ID_ALREADY_EXISTS:
      return "FEDERATED_ID_ALREADY_EXISTS";
    case ErrorType.INVALID_REFRESH_TOKEN:
      return "INVALID_REFRESH_TOKEN";
    case ErrorType.MISSING_REFRESH_TOKEN:
      return "MISSING_REFRESH_TOKEN";
    case ErrorType.INVALID_ACCESS_TOKEN:
      return "INVALID_ACCESS_TOKEN";
    case ErrorType.MISSING_ACCESS_TOKEN:
      return "MISSING_ACCESS_TOKEN";
    case ErrorType.INVALID_GRANT_TYPE:
      return "INVALID_GRANT_TYPE";
    case ErrorType.INVALID_PASSWORD:
      return "INVALID_PASSWORD";
    case ErrorType.INVALID_AUTH_CREDENTIAL:
      return "INVALID_AUTH_CREDENTIAL";
    case ErrorType.INVALID_IDP_RESPONSE:
      return "INVALID_IDP_RESPONSE";
    case ErrorType.INVALID_PUSH_DEVICE_ID:
      return "INVALID_PUSH_DEVICE_ID";
    case ErrorType.INVALID_PLATFORM:
      return "INVALID_PLATFORM";
    case ErrorType.ORDER_INVALID_PAYMENT_TYPE:
      return "ORDER_INVALID_PAYMENT_TYPE";
    case ErrorType.ORDER_INVALID_TOTAL:
      return "ORDER_INVALID_TOTAL";
    case ErrorType.ORDER_EMPTY_CART_ITEM:
      return "ORDER_EMPTY_CART_ITEM";
    case ErrorType.ORDER_INVALID_CART_ITEM:
      return "ORDER_INVALID_CART_ITEM";
    case ErrorType.ORDER_DUPLICATE_CART_ITEM:
      return "ORDER_DUPLICATE_CART_ITEM";
    case ErrorType.ORDER_INVALID_CART_ITEM_IS_NEGATIVE:
      return "ORDER_INVALID_CART_ITEM_IS_NEGATIVE";
    case ErrorType.ORDER_INVALID_RECEIPT_METHOD:
      return "ORDER_INVALID_RECEIPT_METHOD";
    case ErrorType.ORDER_INVALID_MOBILE_BARCODE:
      return "ORDER_INVALID_MOBILE_BARCODE";
    case ErrorType.ORDER_INVALID_TAX_ID:
      return "ORDER_INVALID_TAX_ID";
    case ErrorType.ORDER_INVALID_DONATE_UNIT:
      return "ORDER_INVALID_DONATE_UNIT";
    case ErrorType.ORDER_EMPTY_RECIPIENT_INFO:
      return "ORDER_EMPTY_RECIPIENT_INFO";
    case ErrorType.ORDER_EMPTY_RECIPIENT_NAME:
      return "ORDER_EMPTY_RECIPIENT_NAME";
    case ErrorType.ORDER_RECIPIENT_NAME_INCLUDE_NUMBER:
      return "ORDER_RECIPIENT_NAME_INCLUDE_NUMBER";
    case ErrorType.ORDER_EMPTY_RECIPIENT_PHONE:
      return "ORDER_EMPTY_RECIPIENT_PHONE";
    case ErrorType.ORDER_INVALID_RECIPIENT_PHONE:
      return "ORDER_INVALID_RECIPIENT_PHONE";
    case ErrorType.ORDER_EMPTY_PICKUP_STORE:
      return "ORDER_EMPTY_PICKUP_STORE";
    case ErrorType.ORDER_INVALID_CREDIT_CARD_NUMBER:
      return "ORDER_INVALID_CREDIT_CARD_NUMBER";
    case ErrorType.ORDER_INVALID_CREDIT_CARD_GOOD_THRU:
      return "ORDER_INVALID_CREDIT_CARD_GOOD_THRU";
    case ErrorType.ORDER_INVALID_CREDIT_CARD_CVV:
      return "ORDER_INVALID_CREDIT_CARD_CVV";
    case ErrorType.ORDER_EMPTY_FIRST_NAME:
      return "ORDER_EMPTY_FIRST_NAME";
    case ErrorType.ORDER_EMPTY_LAST_NAME:
      return "ORDER_EMPTY_LAST_NAME";
    case ErrorType.ORDER_INVALID_PHONE_COUNTRY_CODE:
      return "ORDER_INVALID_PHONE_COUNTRY_CODE";
    case ErrorType.ORDER_INVALID_COUNTRY:
      return "ORDER_INVALID_COUNTRY";
    case ErrorType.ORDER_EMPTY_PROVINCE:
      return "ORDER_EMPTY_PROVINCE";
    case ErrorType.ORDER_EMPTY_CITY:
      return "ORDER_EMPTY_CITY";
    case ErrorType.ORDER_EMPTY_STREET:
      return "ORDER_EMPTY_STREET";
    case ErrorType.ORDER_EMPTY_POSTCODE:
      return "ORDER_EMPTY_POSTCODE";
    case ErrorType.ORDER_EMPTY_COUNTY:
      return "ORDER_EMPTY_COUNTY";
    case ErrorType.ORDER_EMPTY_AREA:
      return "ORDER_EMPTY_AREA";
    case ErrorType.RETURN_NOT_FOUND:
      return "RETURN_NOT_FOUND";
    case ErrorType.RETURN_INVALID_LOGISTICS_COMPANY:
      return "RETURN_INVALID_LOGISTICS_COMPANY";
    case ErrorType.RETURN_ORDER_ITEM_NOT_FOUND:
      return "RETURN_ORDER_ITEM_NOT_FOUND";
    case ErrorType.RETURN_ORDER_ITEM_ALREADY_RETURNED:
      return "RETURN_ORDER_ITEM_ALREADY_RETURNED";
    case ErrorType.RETURN_ORDER_REFUND_INVALID_STATE:
      return "RETURN_ORDER_REFUND_INVALID_STATE";
    case ErrorType.RETURN_ORDER_RETURN_INVALID_STATE:
      return "RETURN_ORDER_RETURN_INVALID_STATE";
    case ErrorType.RETURN_REASON_NOTE_EMPTY:
      return "RETURN_REASON_NOTE_EMPTY";
    case ErrorType.RETURN_EXCEED_PURCHASE_QTY:
      return "RETURN_EXCEED_PURCHASE_QTY";
    case ErrorType.RETURN_ORDER_ITEM_NO_RETURNS:
      return "RETURN_ORDER_ITEM_NO_RETURNS";
    case ErrorType.RETURN_UPDATE_LOGISTICS_INVALID_STATE:
      return "RETURN_UPDATE_LOGISTICS_INVALID_STATE";
    case ErrorType.RATING_INVALID_CONTENT:
      return "RATING_INVALID_CONTENT";
    case ErrorType.RATING_TRADITIONAL_CONTENT:
      return "RATING_TRADITIONAL_CONTENT";
    case ErrorType.RATING_ORDER_ITEM_RATED:
      return "RATING_ORDER_ITEM_RATED";
    case ErrorType.RATING_ORDER_NOT_CLAIMED:
      return "RATING_ORDER_NOT_CLAIMED";
    case ErrorType.RATING_ORDER_ITEM_RATING_EXPIRED:
      return "RATING_ORDER_ITEM_RATING_EXPIRED";
    case ErrorType.RATING_EMPTY_CONTENT:
      return "RATING_EMPTY_CONTENT";
    case ErrorType.PRODUCT_NOT_FOUND:
      return "PRODUCT_NOT_FOUND";
    case ErrorType.CATEGORY_NOT_FOUND:
      return "CATEGORY_NOT_FOUND";
    case ErrorType.HOT_KEYWORD_NOT_FOUND:
      return "HOT_KEYWORD_NOT_FOUND";
    case ErrorType.SHOP_WINDOW_NOT_FOUND:
      return "SHOP_WINDOW_NOT_FOUND";
    case ErrorType.CART_ITEM_NO_SALE:
      return "CART_ITEM_NO_SALE";
    case ErrorType.CART_ITEM_ALL_NO_SALE:
      return "CART_ITEM_ALL_NO_SALE";
    case ErrorType.CART_ITEM_SOME_NO_SALE:
      return "CART_ITEM_SOME_NO_SALE";
    case ErrorType.CUSTOMER_RECEIPT_EXIST:
      return "CUSTOMER_RECEIPT_EXIST";
    case ErrorType.CUSTOMER_RECEIPT_NOT_FOUND:
      return "CUSTOMER_RECEIPT_NOT_FOUND";
    case ErrorType.CUSTOMER_RECEIPT_CANNOT_MODIFY:
      return "CUSTOMER_RECEIPT_CANNOT_MODIFY";
    case ErrorType.STATIC_PAGE_NOT_FOUND:
      return "STATIC_PAGE_NOT_FOUND";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum ErrorType");
  }
}

/** ErrorItem is a detailed error code & message from the api frontend. */
export interface ErrorItem {
  /** Code is the typed error code. */
  code: number;
  /** Reason is the typed error string. */
  reason: string;
  /** Message is the human-readable description of the error. */
  message: string;
  /** Action is the suggested action to handle the error. */
  action: ErrorItem_Action;
  /** (optional) Meta provides extra information for the error. */
  meta: { [key: string]: string };
}

export enum ErrorItem_Action {
  ACTION_NONE = 0,
  POP = 1,
  RETRY = 2,
  LOGOUT = 10,
}

export function errorItem_ActionFromJSON(object: any): ErrorItem_Action {
  switch (object) {
    case 0:
    case "ACTION_NONE":
      return ErrorItem_Action.ACTION_NONE;
    case 1:
    case "POP":
      return ErrorItem_Action.POP;
    case 2:
    case "RETRY":
      return ErrorItem_Action.RETRY;
    case 10:
    case "LOGOUT":
      return ErrorItem_Action.LOGOUT;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum ErrorItem_Action");
  }
}

export function errorItem_ActionToJSON(object: ErrorItem_Action): string {
  switch (object) {
    case ErrorItem_Action.ACTION_NONE:
      return "ACTION_NONE";
    case ErrorItem_Action.POP:
      return "POP";
    case ErrorItem_Action.RETRY:
      return "RETRY";
    case ErrorItem_Action.LOGOUT:
      return "LOGOUT";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum ErrorItem_Action");
  }
}

export interface ErrorItem_MetaEntry {
  key: string;
  value: string;
}

function createBaseErrorItem(): ErrorItem {
  return { code: 0, reason: "", message: "", action: 0, meta: {} };
}

export const ErrorItem = {
  fromJSON(object: any): ErrorItem {
    return {
      code: isSet(object.code) ? Number(object.code) : 0,
      reason: isSet(object.reason) ? String(object.reason) : "",
      message: isSet(object.message) ? String(object.message) : "",
      action: isSet(object.action) ? errorItem_ActionFromJSON(object.action) : 0,
      meta: isObject(object.meta)
        ? Object.entries(object.meta).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: ErrorItem): unknown {
    const obj: any = {};
    message.code !== undefined && (obj.code = Math.round(message.code));
    message.reason !== undefined && (obj.reason = message.reason);
    message.message !== undefined && (obj.message = message.message);
    message.action !== undefined && (obj.action = errorItem_ActionToJSON(message.action));
    obj.meta = {};
    if (message.meta) {
      Object.entries(message.meta).forEach(([k, v]) => {
        obj.meta[k] = v;
      });
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ErrorItem>, I>>(base?: I): ErrorItem {
    return ErrorItem.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ErrorItem>, I>>(object: I): ErrorItem {
    const message = createBaseErrorItem();
    message.code = object.code ?? 0;
    message.reason = object.reason ?? "";
    message.message = object.message ?? "";
    message.action = object.action ?? 0;
    message.meta = Object.entries(object.meta ?? {}).reduce<{ [key: string]: string }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = String(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseErrorItem_MetaEntry(): ErrorItem_MetaEntry {
  return { key: "", value: "" };
}

export const ErrorItem_MetaEntry = {
  fromJSON(object: any): ErrorItem_MetaEntry {
    return { key: isSet(object.key) ? String(object.key) : "", value: isSet(object.value) ? String(object.value) : "" };
  },

  toJSON(message: ErrorItem_MetaEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined && (obj.value = message.value);
    return obj;
  },

  create<I extends Exact<DeepPartial<ErrorItem_MetaEntry>, I>>(base?: I): ErrorItem_MetaEntry {
    return ErrorItem_MetaEntry.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ErrorItem_MetaEntry>, I>>(object: I): ErrorItem_MetaEntry {
    const message = createBaseErrorItem_MetaEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var tsProtoGlobalThis: any = (() => {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw "Unable to locate global object";
})();

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
